import * as React  from 'react';
// import { connect } from 'react-redux'
// import { bindActionCreators } from 'redux';
import Base from './base';
import Date from './date';
import String from "./string";

class TimeZone extends Base{
    constructor(props){
        super(props);
        this.groupName = "DateWithUserTimeZone";
        this.dateTimeIdentifier = 'datetime';
        this.timeZoneIdentifier = 'timezone';
    }

    renderOnCard() {
        const dateTime = this.parseCustomFileds(this.props.data, this.dateTimeIdentifier,this.groupName);
        const timeZone = this.parseCustomFileds(this.props.data, this.timeZoneIdentifier,this.groupName);
        
        let title;
        if((dateTime[0] && dateTime[0].Value) && (timeZone && timeZone[0].Value )){
            title = `${dateTime[0].Value}, ${timeZone[0].Value}`
        } else if((dateTime[0] && dateTime[0].Value) && (timeZone && !timeZone[0].Value )){
            title = `${dateTime[0].Value}`
        } else if((dateTime[0] && !dateTime[0].Value) && (timeZone && timeZone[0].Value)){
            title = `${timeZone[0].Value}`
        }

        return (
            <span title={title} className="wkName">
                {(dateTime[0] && dateTime[0].Value) && (timeZone && timeZone[0].Value ) && <>
                    <Date {...this.props} showLabel={true}  returnValueForBlank={""}
                        data={dateTime} timezone={timeZone[0].Value}
                    />
                    (<String {...this.props} showLabel={false}  returnValueForBlank={""}
                    data={timeZone}
                    />)
                </>}
                {(dateTime[0] && dateTime[0].Value) && (timeZone && !timeZone[0].Value ) && 
                    <Date {...this.props} showLabel={true}  returnValueForBlank={""}
                        data={dateTime} 
                    />
                }
                {(dateTime[0] && !dateTime[0].Value) && (timeZone && timeZone[0].Value) &&
                    (<String {...this.props} showLabel={false} returnValueForBlank={""}
                        data={timeZone} 
                    />)
                }
            </span>
        )
    }
    // renderOnGrid() {
    //     const firstName = this.parseCustomFileds(this.props.data, this.firstNameIdentifier,this.groupName);
    //     const lastName = this.parseCustomFileds(this.props.data, this.lastNameIdentifier,this.groupName);
    //     return (
    //         <React.Fragment>
    //             {
    //                 firstName[0].Value && lastName[0].Value &&
    //                 <>
    //                     <Date {...this.props} showLabel={true} returnValueForBlank={""}
    //                         data={lastName} 
    //                     />
    //                     <Date {...this.props} showLabel={true} includeSpace={true} returnValueForBlank={""} preAppendComma={true}
    //                         data={firstName} 
    //                     />
    //                 </>
    //             }
    //             {
    //                 firstName[0].Value && !lastName[0].Value &&
    //                 <>
    //                     <Date {...this.props} showLabel={true} returnValueForBlank={""}
    //                         data={firstName} 
    //                     />
    //                 </>
    //             }
    //             {
    //                 !firstName[0].Value && lastName[0].Value &&
    //                 <>
    //                     <Date {...this.props} showLabel={true} includeSpace={true} returnValueForBlank={""}
    //                         data={lastName} 
    //                     />
    //                 </>
    //             }
                
    //         </React.Fragment>
    //     )
    // }
    renderOnDetail() {
        const dateTime = this.parseCustomFileds(this.props.data, this.dateTimeIdentifier,this.groupName);
        const timeZone = this.parseCustomFileds(this.props.data, this.timeZoneIdentifier,this.groupName);

        return (
            <React.Fragment>
                <Date {...this.props} showLabel={true}  returnValueForBlank={""} data={dateTime}/>
                <String {...this.props} showLabel={false}  returnValueForBlank={""} data={timeZone}/>
            </React.Fragment>
        )
    }

    renderOnCreate() {
        return (
            <Date {...this.props} showLabel={true}  returnValueForBlank={""}/>
        )
    }
}

export default TimeZone;